export default "__VITE_ASSET__ba6bab38__"